import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { Actions, Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import Link from '../../links/Link';
import { JumpSettings as JumpSettingsIcon } from '../../icon/Icons';
import { useIsAdminUser } from '../../../stores/SessionStore';
import { SiteDetailPanel, SiteWanPanel } from '../../panels';
import { SiteFilter, TimeRangeFilter, useSite } from '../../filters';
import SiteAccessPointsPanel from '../../panels/site-access-points-panel/SiteAccessPointsPanel';

export const pageId = 'site-detail';

export default function SiteDetailPage() {
    const site = useSite();
    const showWan = site?.hasWANInterfaces || false;
    const showAccess = site?.hasAccessPoints || false;
    const [isAdminUser] = useIsAdminUser();

    return (
        <Page id={pageId}>
            <PageHeader
                title={site?.name}
                titleActions={
                    site &&
                    !site.deleted &&
                    isAdminUser && (
                        <Actions>
                            <Link to={`/admin/sites/${site?.uuid}`} title={i18n._(t`Edit site configuration`)}>
                                <JumpSettingsIcon fontSize="small" />
                            </Link>
                        </Actions>
                    )
                }
            >
                <FilterContainer>
                    <TimeRangeFilter required />
                    <SiteFilter required />
                </FilterContainer>
            </PageHeader>
            {!!site && (
                <PanelContainer>
                    <SiteDetailPanel
                        hideTitle
                        showWan={showWan || showAccess}
                        autoHeight={showWan || showAccess}
                        flexHeight={!showWan && !showAccess}
                    />
                    {showAccess && <SiteAccessPointsPanel title={t`Wireless`} />}
                    {showWan && <SiteWanPanel title={t`WAN`} />}
                </PanelContainer>
            )}
        </Page>
    );
}
